import { useEffect, useMemo, useRef, useState } from "react";
import styles from "./CreditInvoices.module.scss";
import { TabView, TabPanel } from "primereact/tabview";
import CreateCreditInvoicesForm from "../create-credit-invoices/CreateCreditInvoicesForm";
import CreditInvoiceSummary from "../credit-invoices-summary/CreditInvoiceSummary";
import { ConfirmDialog } from "primereact/confirmdialog";
import { unstable_usePrompt } from "react-router-dom";

export default function CreditInvoices() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [restrictNavigation, setRestrictNavigation] = useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [pendingTabIndex, setPendingTabIndex] = useState(null);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  unstable_usePrompt({
    message:
      "Changes you made may not be saved. Are you sure you want to proceed?",
    when: restrictNavigation
  });
  const accept = () => {
    setRestrictNavigation(false);
    if (pendingTabIndex !== null) {
      setActiveIndex(pendingTabIndex);
      setPendingTabIndex(null); // Clear after use
    }
    setShowConfirmDialog(false);
  };

  return (
    <>
      <div className="grid ">
        <div className="col-12 ">
          <TabView
            className={`${styles?.noBorderForTab} ${styles?.tabViewBotttomBorder}`}
            activeIndex={activeIndex}
            onTabChange={(e) => {
              if (restrictNavigation) {
                setPendingTabIndex(e?.index);
                setShowConfirmDialog(true);
              } else {
                setActiveIndex(e?.index);
              }
            }}
          >
            <TabPanel
              header="Create"
              headerClassName={`${styles?.tabWidth} `}
              className={`${styles?.tab}   ${activeIndex === 0 ? styles?.activeTab : styles?.InactiveTab
                }`}
            >
              <CreateCreditInvoicesForm
                isFileUploaded={setRestrictNavigation}
              />
            </TabPanel>
            <TabPanel
              header="Summary"
              headerClassName={`${styles?.tabWidth} `}
              className={`${styles?.tab} ${activeIndex === 1 ? styles?.activeTab : styles?.InactiveTab
                }`}
            >
              <CreditInvoiceSummary />
            </TabPanel>
          </TabView>
        </div>
      </div>
      {showConfirmDialog && (
        <ConfirmDialog
          visible={showConfirmDialog}
          onHide={() => setShowConfirmDialog(false)}
          message="Changes you made may not be saved. Are you sure you want to switch tabs?"
          header="Confirmation"
          icon="pi pi-exclamation-triangle"
          style={{ width: "50vw", color: "red" }}
          breakpoints={{ "1100px": "75vw", "960px": "100vw" }}
          accept={accept}
        ></ConfirmDialog>
      )}
    </>
  );
}
